// This page is only used when user sign up with Google, but didn't have name set in their Google account.

import { getAuth, updateProfile } from 'firebase/auth'
import { useForm } from 'react-hook-form'
import { Link as ReactRouterLink, Navigate } from 'react-router-dom'
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Link,
  Text,
} from '@chakra-ui/react'

import { useCreateUser } from '@/react-query/user'
import { useDocumentTitle } from '@/views/hooks/useDocumentTitle'

interface ISignUpNameForm {
  name: string
}

const NameSignUp = () => {
  const createUser = useCreateUser()

  const user = getAuth().currentUser
  if (!user) {
    return <Navigate to="/" state={{ from: location }} />
  }

  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    register,
  } = useForm<ISignUpNameForm>()
  const saveUserWithName = async ({ name }: ISignUpNameForm) => {
    try {
      await updateProfile(user, {
        displayName: name,
      })
      await createUser.mutateAsync()
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <form onSubmit={handleSubmit(saveUserWithName)}>
      <FormControl mt={5} isInvalid={Boolean(errors.name)}>
        <FormLabel htmlFor="name">Name</FormLabel>
        <Input
          id="name"
          type="name"
          autoComplete="name"
          {...register('name', {
            required: 'name is required',
          })}
          variant={'brand-solid-white'}
        />
        <FormErrorMessage>
          {errors.name && errors.name.message}
        </FormErrorMessage>
      </FormControl>
      <Button
        className="mt-7 w-full"
        isLoading={isSubmitting}
        type="submit"
        variant="brand-solid"
      >
        Register
      </Button>
    </form>
  )
}

const SignUpName = () => {
  useDocumentTitle('Sign up')

  return (
    <main className="flex-1 flex flex-col justify-center items-center">
      <Heading size={'lg'} className="text-center">
        Finish signing up by entering your name
      </Heading>
      <div className="mt-2">
        <Text>
          Already have an account?{' '}
          <Link
            as={ReactRouterLink}
            color="blue.500"
            className="font-semibold"
            to="/sign-in"
          >
            Sign in
          </Link>
        </Text>
      </div>
      <Box className="w-full max-w-md rounded-lg p-5">
        <NameSignUp />
      </Box>
    </main>
  )
}

export default SignUpName
